<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view  />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Layout/components/AppMain.vue